import _ from 'lodash';
import translatedRoutes from '../config/translatedRoutes';
import menusConfig from '../config/menus';

export default function routesGenerator(country='dk') {
	country = 'dk';
  const { footer } = menusConfig[country];

  const links = _.toArray(translatedRoutes[country])
    .concat(footer.reduce((result, item) => result.concat(item.links), []).filter(item => item.component)) // builds array of footer links with components
    .map(item => {
      return {
        onEnter: (state, replace) => {
          if (item.props && item.props.redirectPath) {
            const delimiter = _.endsWith(state.location.pathname, '/') ? '' : '/';
            replace(state.location.pathname + delimiter + item.props.redirectPath);
          }
        },
        path: item.url,
        getComponent(location, cb) {
          if (item.component) require.ensure([], require => cb(null, require(`../component/${item.component}.jsx`)));
        },
        ...item.props,
      };
    });

  const embedPage = (location, cb) => require.ensure([], require => cb(null, require('../component/VideoEmbed/EmbedPage.jsx')));
  const noMatch = (location, cb) => require.ensure([], require => cb(null, require('../component/404/NoMatch.jsx')));

  const routes = [{
    path: '/embed/:partnerId/:postId',
    getComponent: embedPage,
  }, {
    path: '/embed/:postId',
    getComponent: embedPage,
  }, {
    path: '/mms/:auid',
    getComponent(location, cb) {
      require.ensure([], require => cb(null, require('../component/MMS/MMSPage.jsx')));
    },
  }, {
    path: '/',
    getComponent(location, cb) {
      require.ensure([], require => cb(null, require('../component/Page/App.jsx')));
    },
    indexRoute: {
      getComponent(location, cb) {
        require.ensure([], require => cb(null, require('../component/NewsFeed/NewsFeedPageIndex.jsx')));
      },
    },
    childRoutes: links,
  }, {
    path: '*',
    getComponent(location, cb) {
      require.ensure([], require => cb(null, require('../component/Page/App.jsx')));
    },
    indexRoute: {
      getComponent: noMatch,
    },
    childRoutes: [{
      getComponent: noMatch,
    }],
  }];

  return routes;
}



// WEBPACK FOOTER //
// ./src/util/routesGenerator.js